/** @jsxImportSource @emotion/react */
import React from 'react';
import { Close } from '@mui/icons-material';

const MapPopupFrame = ({
    popupId,
    isVisible,
    title,
    onClose,
    children,
    containerCss,
    headerContent,
    footer,
}) => {
    return (
        <div id={popupId} className="ol-popup" style={{ display: isVisible ? 'block' : 'none' }}>
            <div css={containerCss}>
                <div className="map-popup-container">
                    {(title || onClose || headerContent) && (
                        <div className="map-popup-header-row draggable-header">
                            {headerContent ?? (title && <h3 className="map-popup-header">{title}</h3>)}
                            {onClose && (
                                <button className="map-close-button" onClick={onClose}>
                                    <Close />
                                </button>
                            )}
                        </div>
                    )}
                    <div className="map-popup-body">{children}</div>
                    {footer && <div className="map-popup-footer">{footer}</div>}
                </div>
            </div>
        </div>
    );
};

export default MapPopupFrame;
